"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const mutation = (0, client_1.gql) `
mutation generateActivityReport($query: OrderQueryInput) {
    generateActivityReport(query: $query) {
      url
      message
      __typename
    }
  }
  
`;
exports.default = mutation;
//# sourceMappingURL=generateActivityReport.mutation.js.map